module['exports'] = function(colors) {
  // RoY G BiV
  var rainbowColors = ['red', 'yellow', 'green', 'blue', 'magenta'];
  return function(letter, i, exploded) {
    if (letter === ' ') {
      return letter;
    } else {
      return colors[rainbowColors[i++ % rainbowColors.length]](letter);
    }
  };
};




//////////////////
// WEBPACK FOOTER
// ./~/colors/lib/maps/rainbow.js
// module id = 2215
// module chunks = 0 1